/*
 * Custom Size Picker
 * Standalone web component — card-based size selector with images.
 */

class SizePickerCustom extends HTMLElement {
  connectedCallback() {
    this.cards = this.querySelectorAll('.szp__card');
    this.selectedLabel = this.querySelector('[data-szp-selected-label]');

    if (this.cards.length === 0) return;

    // Update label on card click
    this.cards.forEach(card => {
      card.addEventListener('click', () => {
        if (card.classList.contains('is-disabled')) return;
        const name = card.dataset.szpSizeName;
        if (name && this.selectedLabel) {
          this.selectedLabel.textContent = name;
        }
      });
    });

    // Listen to radio changes (keyboard nav + programmatic)
    const radios = this.querySelectorAll('input[type="radio"]');
    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        const label = radio.nextElementSibling;
        if (label && label.dataset.szpSizeName && this.selectedLabel) {
          this.selectedLabel.textContent = label.dataset.szpSizeName;
        }
        // Update selected class
        this.cards.forEach(c => c.classList.remove('is-selected'));
        if (label) label.classList.add('is-selected');
      });
    });

    // Listen for variant:change from theme's variant-picker
    const form = this.closest('form[data-type="add-to-cart-form"]');
    if (form) {
      form.addEventListener('variant:change', () => {
        setTimeout(() => {
          const checked = this.querySelector('input:checked');
          if (checked) {
            const label = checked.nextElementSibling;
            if (label && label.dataset.szpSizeName && this.selectedLabel) {
              this.selectedLabel.textContent = label.dataset.szpSizeName;
            }
            this.cards.forEach(c => c.classList.remove('is-selected'));
            if (label) label.classList.add('is-selected');
          }
        }, 10);
      });
    }
  }
}

if (!customElements.get('size-picker-custom')) {
  customElements.define('size-picker-custom', SizePickerCustom);
}
